import { render, staticRenderFns } from "./ModalAccionista.vue?vue&type=template&id=137235ec"
import script from "./ModalAccionista.vue?vue&type=script&lang=js"
export * from "./ModalAccionista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137235ec')) {
      api.createRecord('137235ec', component.options)
    } else {
      api.reload('137235ec', component.options)
    }
    module.hot.accept("./ModalAccionista.vue?vue&type=template&id=137235ec", function () {
      api.rerender('137235ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/complementainfo/ModalAccionista.vue"
export default component.exports